<div class="vm-primary-nav">
  <nav class="vm-hamburger-nav"
       role="navigation"
       [ngStyle]="{ width: visible ? width + unitType : '0' + unitType }">
    <div class="vm-hamburger"
         [ngStyle]="{
        left: visible ? width + unitType : '0' + unitType,
        position: buttonPosition
      }">
      <button type="button"
              *ngIf="showDefaultButton"
              [ngClass]="{ 'is-closed': !visible, 'is-open': visible }"
              class="vm-hamburger-btn"
              (click)="toggleMenu($event)">
        <span class="hamb-top"></span>
        <span class="hamb-middle"></span>
        <span class="hamb-bottom"></span>
      </button>
    </div>
    <div *ngIf="visible">
      <div class="vm-hamburger-nav__list" style="width: 100%" clickElseWhere (onClickElseWhere)="toggleMenu($event)">
        <ng-container *ngTemplateOutlet="content"> </ng-container>
      </div>
    </div>
  </nav>
</div>
<ng-template #content>
  <ng-content></ng-content>
</ng-template>
